/**
 * Set ui schema property with value form reference field
 * @param {String} params.field -
 * @param {String} params.dataField - source of data 
 * @param {String} params.uiProperty - proprty wich value is set
 */
export const uiSetWith = function (params: any, schema: any, uiSchema: any, formData: any) {
  const { field, dataField, uiProperty } = params;
  const [firstUi, secondUi] = field.split(".");
  const [firstData, secondData] = dataField.split(".");
  const data = secondData ? formData[firstData][secondData] : formData[dataField];
  if (!uiSchema[firstUi]) return;

  if (secondUi) {
    uiSchema[firstUi][secondUi][uiProperty] = data;
  } else {
    uiSchema[field][uiProperty] = data;

  }

};


// Action validation
if (process.env.NODE_ENV !== "production") {

  const PropTypes = require("prop-types");

  uiSetWith.propTypes = {
    field: PropTypes.string,
    dataField: PropTypes.string,
    uiProperty: PropTypes.string
  };

}